const FONT_FAMILY_CSS_STACKS: Record<string, string> = {
  Fredoka: 'Fredoka, Noto Sans KR',
  FredokaPreview: 'FredokaPreview, Noto Sans KR',
};

const FONT_FAMILY_FALLBACKS: Record<string, readonly string[]> = {
  Fredoka: ['Noto Sans KR'],
  FredokaPreview: ['Noto Sans KR'],
};

export const resolveFontFamilyCssStack = (fontFamily: string): string =>
  FONT_FAMILY_CSS_STACKS[fontFamily] ?? fontFamily;

export const getFontFamilyFallbacks = (fontFamily: string): readonly string[] =>
  FONT_FAMILY_FALLBACKS[fontFamily] ?? [];
